import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=c7f8ecfe&scoped=true&"
import script from "./UpgradeCard.vue?vue&type=script&lang=js&"
export * from "./UpgradeCard.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeCard.vue?vue&type=style&index=0&id=c7f8ecfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f8ecfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle})
